import { RootState } from 'store/store';

import { PaymentStatus, aiRequestsModelsConfiguration } from 'core/enums/common';
import {
	BillingHistoryItem,
	ISocketConnectionData,
	PaginationType,
	PaymentMethodType,
	UserFile,
} from 'core/types/base';

import { IUserReducer } from './types';

export const getUser = (state: RootState): IUserReducer => state.userRedux;

export const getIsOpenUserProfile = (state: RootState): boolean =>
	state.userRedux.isOpenUserProfile;

export const getIsExportModalOpen = (state: RootState): boolean =>
	state.userRedux.isExportModalOpen;

export const getIsLoading = (state: RootState): boolean | undefined => state.userRedux.loading;

export const getUserBalance = (state: RootState): number | undefined => state.userRedux.userBalance;

export const getCurrentSubscription = (state: RootState) => state.userRedux.currentSubscription;

export const getUserBalanceError = (state: RootState): string | null | undefined =>
	state.userRedux.getUserBalanceError;

export const getPaymentStatus = (state: RootState): PaymentStatus | null | undefined =>
	state.userRedux.paymentStatus;

export const getMethodStatus = (state: RootState): PaymentStatus | null | undefined =>
	state.userRedux.methodStatus;

export const getPaymentMethods = (state: RootState): PaymentMethodType[] | undefined =>
	state.userRedux.paymentMethods;

export const getStripeConnection = (state: RootState): boolean | undefined =>
	state.userRedux.stripeConnection;

export const getStripeInstance = (state: RootState): ISocketConnectionData | undefined =>
	state.userRedux.stripeInstance;

export const getHasMorePayments = (
	state: RootState
): { start: boolean; end: boolean } | undefined => state.userRedux.hasMorePayments;

export const getBillingHistory = (state: RootState): BillingHistoryItem[] | undefined =>
	state.userRedux.billingHistory;

export const getHasMoreBillingHistory = (
	state: RootState
): { start: boolean; end: boolean } | undefined => state.userRedux.hasMoreHistory;

export const getNotEnoughTokensError = (state: RootState): boolean | null | undefined =>
	state.userRedux.notEnoughTokensError;

export const getTicketSaveTrigger = (state: RootState): boolean =>
	state.userRedux.ticketSaveTrigger;

export const getUserFiles = (state: RootState): UserFile[] | undefined => state.userRedux.userFiles;

export const getAiRequestsModelsConfiguration = (state: RootState): aiRequestsModelsConfiguration =>
	state.userRedux.aiRequestsModelsConfiguration;

export const getUserFilesPagination = (state: RootState): PaginationType | null | undefined =>
	state.userRedux.userFilesPagination;

export const getChoosedFile = (state: RootState): UserFile | undefined | null =>
	state.userRedux.choosedFile;

export const getDeniedAccessError = (state: RootState): boolean | undefined =>
	state.userRedux.deniedAccessError;

export const getQueueDelayNotification = (state: RootState): boolean | undefined =>
	state.userRedux.queueDelayNotification;

export const getIsDeleteAccessModal = (state: RootState): boolean =>
	state.userRedux.isOpenNoDeleteAccess;

export const getLoadedUsers = (state: RootState) => state.userRedux.loadedUsers;
